import { create } from 'zustand';

export type PartnerApiErrorPopupPayload = {
    title: string;
    message: string;
    detail?: string;
    statusCode?: number;
};

type PartnerApiErrorStore = {
    popup: PartnerApiErrorPopupPayload | null;
    suppressDepth: number;
    showPartnerApiErrorPopup: (payload: PartnerApiErrorPopupPayload) => void;
    clearPartnerApiErrorPopup: () => void;
    pushSuppressPartnerErrorPopup: () => () => void;
    isPartnerErrorPopupSuppressed: () => boolean;
};

export const usePartnerApiErrorStore = create<PartnerApiErrorStore>((set, get) => ({
    popup: null,
    suppressDepth: 0,
    showPartnerApiErrorPopup: (payload) => {
        if (get().suppressDepth > 0) return;
        set({ popup: payload });
    },
    clearPartnerApiErrorPopup: () => set({ popup: null }),
    pushSuppressPartnerErrorPopup: () => {
        set((s) => ({ suppressDepth: s.suppressDepth + 1 }));
        return () => set((s) => ({ suppressDepth: Math.max(0, s.suppressDepth - 1) }));
    },
    isPartnerErrorPopupSuppressed: () => get().suppressDepth > 0,
}));
